/* eslint-disable import/max-dependencies */
import { createSelector } from "reselect";

import type { State } from "../../pages/AppStoreWrapper";
import type { Page } from "../../components/FormDialog/types/FormDialog.types";
import type { State as ImportState } from "../../reducers/importPage";
import type { State as CloneState } from "../../reducers/clonePage";
import type { State as ExportState } from "../../reducers/exportPage";
import type { Page as ExportPage } from "../../reducers/exportPage/reducer";

export const getIsPageImportingOpen = createSelector(
  (state: State): ImportState => state.page.importPage,
  (importing: ImportState): boolean => importing.get("isOpen", false)
);

export const getIsPageCloningOpen = createSelector(
  (state: State): CloneState => state.page.clonePage,
  (importing: CloneState): boolean => importing.get("isOpen", false)
);

export const getCloningSelectedPage = createSelector(
  (state: State): CloneState => state.page.clonePage,
  (importing: CloneState): Page => importing.get("selectedPage")
);

export const getIsPageExportingOpen = createSelector(
  (state: State): ExportState => state.page.exportPage,
  (importing: ExportState): boolean => importing.get("isOpen", false)
);

export const getExportingSelectedPage = createSelector(
  (state: State): ExportState => state.page.exportPage,
  (exporting: ExportState): ExportPage => exporting.get("selectedPage")
);
